<template>
  <div class="dialog-simulate">
    <el-dialog
      v-model="isDialog"
      title=""
      width="30%"
      @close="closeDialog"
    >
      <template #title>
        <span v-if="isError" class="font-20 font-w-bold">
          {{ $t('webhook.save_failed') }}
        </span>
        <span v-else class="font-20 font-w-bold">
          {{ $t('webhook.save_success') }}
        </span>
      </template>
      <el-alert
        v-if="isError"
        :closable="false"
        center
        style="background: #FFF2E3;">
        <template #default>
          <img src="@/assets/icons/bx-window-close.png" height="90" />
        </template>
      </el-alert>
      <el-alert
        v-else
        :closable="false"
        center
        style="background: #E5F4FF;">
        <template #default>
          <img src="@/assets/icons/bx-window-success.png" height="90" />
        </template>
      </el-alert>
      <div v-if="isError" class="font-14 my-16">
        {{ $t('webhook.message_failed') }}
      </div>
      <div v-else class="font-14 my-16">
        {{ $t('webhook.message_success') }}
      </div>
      <el-scrollbar height="120px">
        <el-row justify="space-between" class="mx-4">
          <el-col :span="22">
            <div>{{ responseWebhook }}</div>
          </el-col>
          <el-col :span="2">
            <el-popover
              placement="left"
              trigger="click"
              content="Copied"
              class="topp"
            >
              <template #reference>
                <el-icon
                  class="pointer ml-12 mt-4"
                  @click="copyWebhook()"
                >
                  <img src="@/assets/icons/bx-window-copy.png" height="20" />
                </el-icon>
              </template>
            </el-popover>
          </el-col>
        </el-row>
      </el-scrollbar>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            class="btn-full-block font-w-semi-bold"
            @click="closeDialog"
          >
            {{ $t('webhook.wb_close') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
    required: false
  },
  isError: {
    type: Boolean,
    default: false,
    required: false
  },
  responseWebhook: {
    type: Object,
    default: () => {},
    required: false
  }
})

const emit = defineEmits(['update:modelValue'])

const isDialog = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const copyWebhook = () => {
  const response = JSON.stringify(props.responseWebhook, null, 4)
  navigator.clipboard.writeText(response)
}
const closeDialog = () => {
  isDialog.value = false
}
</script>

<style lang="scss">
.dialog-simulate {
  & .el-overlay {
    z-index: 3000 !important;
  }
  & .el-dialog {
    border-radius: 10px !important;
    & .el-dialog__body {
      padding-top: 16px;
    }
  }
}
.el-popper.is-light.el-popover--plain {
  z-index: 4000 !important;
}
</style>
